import { type ImageInterface } from 'Image/types';
import { modifyHref } from 'NavigationHelpers';

// Only ever read the original format; sized renditions come from the
// image-resizer Cloudflare worker (see sizedUrl).
export function originalUrl(image: ImageInterface | null | undefined): string | null {
    const url = image?.formats?.original?.url;
    return url ? modifyHref(url) : null;
}

export default originalUrl;
